import type { FC } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { ReferAFriend as UIReferAFriend } from "@jti/loyalty/components/ReferAFriend";

import type { referAFriendInputs } from "./ReferAFriend.builder";

type ReferAFriendBuilderProps = BuilderComponentProps<typeof referAFriendInputs>;

export const ReferAFriend: FC<ReferAFriendBuilderProps> = ({
  registerTitle,
  registerUrl,
  signInTitle,
  signInUrl,
  stepslist,
  stepslistloggedout,
  subtitle,
  title,
  variant,
  subtitleDetails,
  componentId,
}) => {
  return (
    <UIReferAFriend
      registerTitle={registerTitle}
      registerUrl={registerUrl}
      signInTitle={signInTitle}
      signInUrl={signInUrl}
      stepslist={stepslist}
      stepslistloggedout={stepslistloggedout ?? []}
      subtitle={subtitle}
      title={title}
      variant={variant}
      subtitleDetails={subtitleDetails}
      componentId={componentId}
      isInEditor={isEditing()}
    />
  );
};
